var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"w-form__label",class:{
    'w-form__label--disabled': _vm.disabled,
    'w-form__label--required': _vm.required,
  },attrs:{"for":_vm.forId}},[_vm._t("default"),_vm._v(" "),(_vm.required)?_c('span',{staticClass:"w-form__label__required-indicator"},[_vm._v("\n    *\n  ")]):(_vm.isOptional)?_c('span',{staticClass:"w-form__label--is-optional"},[_vm._v("\n    (Optional)\n  ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }